import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetWorkCenterList = createModule({
  base: 'GET_WORK_CENTER_LIST', apiDetails: {...SERVICE_ENDPOINT.WORK_CENTER, method: 'get'},
});

const AddWorkCenter = createModule({
  base: 'ADD_WORK_CENTER', apiDetails: {...SERVICE_ENDPOINT.WORK_CENTER, method: 'post'}, enableNotification: true,
});

const UpdateWorkCenter = createModule({
  base: 'UPDATE_WORK_CENTER', apiDetails: {...SERVICE_ENDPOINT.WORK_CENTER, method: 'put'}, enableNotification: true,
});

const DeleteWorkCenter = createModule({
  base: 'DELETE_WORK_CENTER', apiDetails: {...SERVICE_ENDPOINT.WORK_CENTER, method: 'delete'}, enableNotification: true,
});

export {
  GetWorkCenterList, AddWorkCenter, UpdateWorkCenter, DeleteWorkCenter,
};
